import React, { ReactNode } from 'react';

import {
  LibraryFolderActionProvider,
  LibraryFolderActionProviderProps,
  LibraryQuizActionProvider,
  LibraryQuizActionProviderProps,
  TrashFolderActionProvider,
  TrashFolderActionProviderProps,
  TrashQuizActionProvider,
  TrashQuizActionProviderProps,
} from '~teacher/components/quizzes/QuizListItem/ActionProviders';

type Props = Partial<
  LibraryFolderActionProviderProps &
    LibraryQuizActionProviderProps &
    TrashFolderActionProviderProps &
    TrashQuizActionProviderProps
> & {
  children: ReactNode;
};

export function ItemActionsProvider({
  children,
  onOpenRenameFolder,
  onDeleteFolder,
  onDeleteQuiz,
  onRestoreFolder,
  onPurgeFolder,
  onRestoreQuiz,
  onPurgeQuiz,
  openMoveDialog,
}: Props) {
  return (
    <LibraryFolderActionProvider
      onOpenRenameFolder={onOpenRenameFolder}
      onDeleteFolder={onDeleteFolder}
      openMoveDialog={openMoveDialog}
    >
      <LibraryQuizActionProvider
        onDeleteQuiz={onDeleteQuiz}
        openMoveDialog={openMoveDialog}
        openCopyDialog={() => {
          /* */
        }}
      >
        <TrashFolderActionProvider
          onRestoreFolder={onRestoreFolder}
          onPurgeFolder={onPurgeFolder}
        >
          <TrashQuizActionProvider
            onRestoreQuiz={onRestoreQuiz}
            onPurgeQuiz={onPurgeQuiz}
          >
            {children}
          </TrashQuizActionProvider>
        </TrashFolderActionProvider>
      </LibraryQuizActionProvider>
    </LibraryFolderActionProvider>
  );
}
